import Banner from '../comps/Banner';
import FootTC from '../comps/FootTC';
import ListA from '../compsNa/ListA';
import ListB from '../compsNa/ListB';
import ListC from '../compsNa/ListC';
import OtherA from '../compsNa/OtherA';
import SectionA from '../compsNa/SectionA';
import SectionB from '../compsNa/SectionB';
import SectionC from '../compsNa/SectionC';
import SectionD from '../compsNa/SectionD';
import SectionE from '../compsNa/SectionE';
import SectionF from '../compsNa/SectionF';
import SectionG from '../compsNa/SectionG';
import TabA from '../compsNa/TabA';
import TabB from '../compsNa/TabB';
import TabC from '../compsNa/TabC';
import WhatInBox from '../compsNa/WhatInBox';
import XCore from '../compsNa/XCore';
import styles from './ProductContent.module.scss';

export default function ProductNa() {
    return (
        <div className={styles.teaser}>
            <Banner />
            <OtherA />
            <SectionA />
            <SectionB />
            <SectionC />

            <TabA />
            <SectionD />
            <SectionE />
            <SectionF />
            <SectionG />
            <TabB />
            <ListC />
            <TabC />
            <ListA />
            <ListB />
            <XCore />
            <WhatInBox />
            <FootTC />
        </div>
    );
}
